import { MessageFromFrame } from '../types';

export const extractPromocodeFromMessage = (messageFromFrame: MessageFromFrame) => {
  try {
    return JSON.parse(messageFromFrame.data)['depositCode'];
  } catch {
    return undefined;
  }
};
